module.exports = __webpack_public_path__ + "img/Logout.f321edc4.svg";